/**
 * Qwen 批任务单张重试路由：有 detect bbox → crop-by-bbox；否则 → Worker 同步重试（detect + crop）。
 */

function trimOrEmpty(value) {
  return value == null ? '' : String(value).trim();
}

/** @returns {number[] | null} 归一化 bbox [x_min, y_min, x_max, y_max]（0–1000） */
export function extractBboxNormalized(cropPosition) {
  if (!cropPosition || typeof cropPosition !== 'object') return null;
  const raw = cropPosition.bboxNormalized ?? cropPosition.bbox_normalized;
  if (!Array.isArray(raw) || raw.length !== 4) return null;
  const nums = raw.map((v) => Number(v));
  if (nums.some((n) => !Number.isFinite(n))) return null;
  return nums;
}

export function extractCropRetryMeta(cropPosition) {
  if (!cropPosition || typeof cropPosition !== 'object') {
    return { confidence: undefined, label: undefined };
  }
  const confidenceRaw = cropPosition.confidence;
  const confidence = confidenceRaw == null ? undefined : Number(confidenceRaw);
  const label = trimOrEmpty(cropPosition.label) || undefined;
  return {
    confidence: Number.isFinite(confidence) ? confidence : undefined,
    label,
  };
}

/**
 * @param {import('@/utils/api').cropImageAPI} cropImageAPI
 * @param {{
 *   taskId: string,
 *   imageId: string,
 *   imageUrl: string,
 *   cropPosition?: object | null,
 * }} params
 */
export function buildImageCropRetryRequest(cropImageAPI, params) {
  const taskId = trimOrEmpty(params?.taskId);
  const imageId = trimOrEmpty(params?.imageId);
  const imageUrl = trimOrEmpty(params?.imageUrl);
  const bbox = extractBboxNormalized(params?.cropPosition);
  const meta = extractCropRetryMeta(params?.cropPosition);

  if (bbox) {
    return {
      strategy: 'bbox',
      call: () => cropImageAPI.cropByBbox({
        taskId,
        imageId,
        imageUrl,
        bbox,
        confidence: meta.confidence,
        label: meta.label,
      }),
    };
  }

  return {
    strategy: 'qwen-worker',
    call: () => cropImageAPI.retryQwenWorkerItem({ taskId, imageId, imageUrl }),
  };
}
